/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type HomeAnchorMappingKindEnum =
  (typeof HomeAnchorMappingKindEnum)[keyof typeof HomeAnchorMappingKindEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HomeAnchorMappingKindEnum = {
  Missing: 0,
  Change: 1,
  Unchanged: 2,
  Added: 3,
} as const;
